import { Fee } from "app/shared/model/Fee";

export const toFeeCodeDto = (raw: string): string => {
    const s = String(raw ?? "").trim();

    const m1 = /^F(\d+)$/i.exec(s);
    if (m1) return `F${m1[1]}`;

    const m2 = /^Fee-(\d+)$/i.exec(s);
    if (m2) return `F${m2[1]}`;

    const m3 = /^(\d+)$/.exec(s);
    if (m3) return `F${m3[1]}`;

    return s;
};

export const fromFeeCodeDto = (raw: string): string => {
    const s = String(raw ?? "").trim();

    const m1 = /^F(\d+)$/i.exec(s);
    if (m1) return m1[1];

    const m2 = /^Fee-(\d+)$/i.exec(s);
    if (m2) return m2[1];

    const m3 = /^(\d+)$/.exec(s);
    if (m3) return m3[1];

    return s;
};

export const resolveFeeSelectionKey = (raw: string, fees: Fee[]): string => {
    const s = String(raw ?? "").trim();
    if (!s) return s;

    const normalisedId = fromFeeCodeDto(s);
    if (/^\d+$/.test(normalisedId)) {
        const byId = fees.find(f => String(f.id) === normalisedId);
        if (byId) return String(byId.id);
        return normalisedId;
    }

    const byName = fees.find(f => f.name === s || f.name === normalisedId);
    if (byName) return String(byName.id);

    return normalisedId;
};

export const isFeeSelected = (fee: Fee, selectedFees: Record<string, boolean | undefined>): boolean => {
    const idKey = String(fee.id);
    if (selectedFees[idKey]) return true;
    if (selectedFees[`F${fee.id}`] || selectedFees[`f${fee.id}`]) return true;
    if (selectedFees[`Fee-${fee.id}`]) return true;
    if (fee.name && selectedFees[fee.name]) return true;
    return false;
};